<template>
  <div>
    <div>
      <div class="md-layout md-alignment-center">
        <div class="md-layout-item my-title">
          奖励设置：
        </div>
        <div class="md-layout-item">
          <md-button class="md-icon-button md-raised md-primary" @click="showAddContact()">
            <md-icon>add</md-icon>
          </md-button>
        </div>
      </div>
      <draggable v-model="rewardSettings.contact_data" draggable=".item">
        <div v-for="element in rewardSettings.contact_data" :key="element.content" class="item">
          <div class="md-layout md-alignment-center">
            <div class="md-layout-item">
              <p>{{ element.title }}{{ element.content }}</p>
            </div>
            <div class="md-layout-item">
              <md-button class="md-icon-button md-raised md-accent md-dense" @click="removeContactItem(element)">
                <md-icon>clear</md-icon>
              </md-button>
            </div>
          </div>
        </div>
      </draggable>

      <md-dialog :md-active.sync="showAddContactDialog">
        <md-dialog-title>添加联系方式</md-dialog-title>
        <div class="dialog_content">
          <md-field>
            <label>标题：</label>
            <md-input v-model="newContact.title"></md-input>
          </md-field>
          <md-field>
            <label>内容</label>
            <md-input v-model="newContact.content"></md-input>
          </md-field>
        </div>
        <md-dialog-actions>
          <md-button class="md-accent" @click="showAddContactDialog = false">取消</md-button>
          <md-button class="md-primary" @click="addContactItem">添加</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>

    <div class="md-layout md-alignment-center-left">
      <div class="md-layout-item">
        <md-field>
          <label>奖励图片地址</label>
          <md-input v-model="rewardSettings.reward_img_url"></md-input>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-alignment-center-left">
      <div class="md-layout-item">
        <md-field>
          <label>客服图片地址</label>
          <md-input v-model="rewardSettings.help_img_url"></md-input>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-alignment-center-right">
      <md-button class="md-fab" @click="saveRewardSettings">
        <md-icon>save</md-icon>
      </md-button>
    </div>

    <md-snackbar :md-active.sync="toast">{{ toastMsg }}</md-snackbar>

  </div>
</template>

<script>

import draggable from 'vuedraggable'

export default {
  name: "RewardManager",
  components: {
    draggable,
  },
  data: () => ({
    rewardSettings: {
      need_count: 0,
      watch_duration: 0,
      no_reward_img_url: '',
      no_reward_img_url_two_left: '',
      no_reward_img_url_one_left: '',
      reward_img_url: '',
      help_img_url: '',
      contact_data: []
    },
    showAddContactDialog: false,
    newContact: {
      title: '',
      content: '',
    },
    toast: false,
    toastMsg: "",
  }),
  mounted() {
    this.getRewardSettings();
  },
  methods: {
    getRewardSettings: function () {
      this.$http.get('/api/app/resources/reward/').then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.rewardSettings = data.data;
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('获取失败，服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status !== 403) {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    showAddContact: function () {
      this.showAddContactDialog = true;
    },
    addContactItem: function () {
      if (!this.newContact.title) {
        this.showErrorTips("必须输入标题");
        return;
      }
      if (!this.newContact.content) {
        this.showErrorTips("必须输入内容");
        return;
      }
      this.rewardSettings.contact_data.push({
        title: this.newContact.title,
        content: this.newContact.content,
      });
      this.newContact = {};
      this.showAddContactDialog = false;
    },
    removeContactItem: function (item) {
      const index = this.rewardSettings.contact_data.indexOf(item);
      if (index > -1) {
        this.rewardSettings.contact_data.splice(index, 1);
      }
    },
    saveRewardSettings: function () {
      this.$http.post('/api/app/resources/reward/', this.rewardSettings).then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.showTips('修改成功');
                this.getRewardSettings();
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status !== 403) {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    showTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
    showErrorTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
  },
}
</script>

<style scoped>
.my-title {
  font-size: 18px;
  text-align: left;
}
</style>